import styled from 'styled-components';

import Icon from '@/components/Shared/Icon';
import {
  colorAccent,
  colorSecondary400,
  colorWhite,
  fontFamilySecondary,
} from '@/styleUtils';

export const FullHeightWaitingScreen = styled.div`
  position: absolute;
  top: 0;
  height: 100vh;
  width: 100vw;
  background: rgba(255, 255, 255, 0.4);
  z-index: 1;
`;
export const StandardWaitingScreen = styled.div`
  position: absolute;
  top: 56px;
  height: 100%;
  width: 100vw;
  background: ${colorWhite};
  z-index: 1;
`;
export const StyledIcon = styled(Icon)`
  color: ${({ $isMinfinColors }) =>
    $isMinfinColors ? colorAccent : colorSecondary400};
  position: absolute;
  top: 59px;
  left: calc(50% - 24px);
  animation: spin 1s linear infinite;
  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;
export const Spinner = styled.img`
  width: 48px;
  height: 48px;
  position: absolute;
  top: calc(50% - 48px);
  left: calc(50% - 24px);
  animation: spin 1s linear infinite;
  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;
export const Text = styled.div`
  font: 700 18px / 24px ${fontFamilySecondary};
  margin-top: 115px;
  text-align: center;
`;
